import React from 'react'
import PropTypes from 'prop-types'
import Tile from './Tile'
import styled from 'styled-components'
import type { Pokemon } from './types'

const StyledBoard = styled.div`
  grid-area: 1 / 2 / 5 / 5;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  @media (max-width: 480px) {
    grid-area: 1;
  }
`

const StyledRow = styled.div<{ $backgroundColor: string }>`
  grid-column: 1 / 5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: ${props => props.$backgroundColor};
  border-radius: 5px;
  border: 1px solid black;
  font-weight: bold;
  font-size: 1.25rem;
  text-transform: capitalize;
  color: #333;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
  height: 6rem;
  width: 36rem;

  @media (max-width: 768px) {
    width: 28rem;
    height: 4rem;
    font-size: .85rem;
  }

  @media (max-width: 480px) {
    width: 20rem;
    height: 2.5rem;
    font-size: .75rem;
  }
`

const color = ['#FFD700', '#C0C0C0', '#CD7F32', '#FF0000']

interface BoardProps {
  unsolvedPokemon: Pokemon[]
  selectedPokemon: Pokemon[]
  setSelectedPokemon: React.Dispatch<React.SetStateAction<Pokemon[]>>
  solvedGroups: string[]
  isSubmitted: boolean
}

const Board = ({ unsolvedPokemon, selectedPokemon, setSelectedPokemon, solvedGroups, isSubmitted }: BoardProps): JSX.Element => {
  function handleSelect (pokemon: Pokemon): void {
    if (selectedPokemon.length >= 4 && !selectedPokemon.includes(pokemon)) {
      return
    }

    if (selectedPokemon.length === 0) {
      setSelectedPokemon([pokemon])
    } else if ((selectedPokemon.length > 0) && selectedPokemon.includes(pokemon)) {
      const newSelectedPokemon = selectedPokemon.filter(p => p !== pokemon)
      setSelectedPokemon(newSelectedPokemon)
    } else {
      setSelectedPokemon([...selectedPokemon, pokemon])
    }
  }

  return (
    <StyledBoard>
        {solvedGroups.map((group, index) => {
          return (
            <StyledRow key={index} $backgroundColor={color[index]}>{group}</StyledRow>
          )
        })}
        {unsolvedPokemon.map((pokemon, index) => {
          const isSelected = selectedPokemon.includes(pokemon)
          return (
            <Tile
              key={index}
              pokemon={pokemon}
              handleClick={handleSelect}
              shake={isSubmitted && isSelected}
              isSelected={(selectedPokemon.length > 0) && isSelected} />
          )
        })}
    </StyledBoard>
  )
}

Board.propTypes = {
  unsolvedPokemon: PropTypes.array.isRequired,
  selectedPokemon: PropTypes.array.isRequired,
  setSelectedPokemon: PropTypes.func.isRequired,
  solvedGroups: PropTypes.array.isRequired
}

export default Board
